import api from '@/lib/axios';

export interface LocalizedString {
  tr: string;
  en: string;
  fr: string;
  es: string;
  ru: string;
  nl: string;
  ar: string;
}

export interface HeroSlide {
  _id: string;
  mediaType: 'image' | 'video';
  mediaUrl: string;
  mediaFileName: string;
  title: LocalizedString;
  description: LocalizedString;
  localizedTitle?: string;
  localizedDescription?: string;
  isActive: boolean;
  order: number;
  createdAt: string;
}

const API_BASE_URL = '/hero-slider';

export const heroSliderService = {
  // Get all slides
  async getSlides(params?: { lang?: string; active?: boolean }): Promise<HeroSlide[]> {
    const response = await api.get(API_BASE_URL, { params });
    return response.data.data;
  },

  // Get slide by ID
  async getSlide(id: string, params?: { lang?: string }): Promise<HeroSlide> {
    const response = await api.get(`${API_BASE_URL}/${id}`, { params });
    return response.data.data;
  },

  // Create new slide
  async createSlide(formData: FormData, translate = false): Promise<HeroSlide> {
    const response = await api.post(`${API_BASE_URL}?translate=${translate}`, formData);
    return response.data.data;
  },

  // Update slide
  async updateSlide(id: string, formData: FormData, translate = false): Promise<HeroSlide> {
    const response = await api.put(`${API_BASE_URL}/${id}?translate=${translate}`, formData);
    return response.data.data;
  },

  // Delete slide
  async deleteSlide(id: string): Promise<void> {
    await api.delete(`${API_BASE_URL}/${id}`);
  },

  // Update slide order
  async updateSlideOrder(orders: { id: string; order: number }[]): Promise<void> {
    await api.patch(`${API_BASE_URL}/reorder`, { orders });
  },
};
